var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "appendix" }, [
    _vm.list
      ? _c("section", { staticClass: "appendix-news" }, [
          _c("div", { staticClass: "product-description" }, [
            _c("h2", { staticClass: " half" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _c(
            "section",
            { staticClass: "card-column-list" },
            _vm._l(_vm.list, function(item) {
              return _c(
                "card-case-small",
                {
                  key: item.id,
                  attrs: {
                    title: item.title,
                    date: item.date,
                    image: item.image,
                    id: item.id,
                    link: _vm.url + item.id,
                    text: item.text
                  }
                },
                [_c("span", { domProps: { innerHTML: _vm._s(item.text) } })]
              )
            })
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145e1b9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145e1b9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/articles/ArticleRelated.vue
// module id = nGq0
// module chunks = 3 4 7 8 9